import { DateTime } from "luxon";

export const QUICK_DUE_DATE_OPTIONS = [
  { label: "3 days", compactLabel: "3 days", days: 3 },
  { label: "1 week", compactLabel: "1 wk", days: 7 },
  { label: "1 month", compactLabel: "1 mo", days: 30 }
] as const;

export type QuickDueDateOption = (typeof QUICK_DUE_DATE_OPTIONS)[number];

export function quickDueDateChipLabel(option: QuickDueDateOption, compact: boolean): string {
  return compact ? option.compactLabel : option.label;
}

export const DEFAULT_QUICK_DUE_DATE_DAYS = 3;

export function isoDateDaysFromNow(days: number, now: DateTime = DateTime.now()): string | null {
  return now.plus({ days }).toISODate();
}
